import { VehicleTypeFlags } from '../enums';
import { vehiclesEligibleForMCTagging } from "../../common";
export const VEHICLE_MODULE_PREFIX = 'VEHICLE';
export const DEFAULT_LANGUAGE = 'ENG';
export const SPECIALTY_VEHICLES_TYPE_IDS = [20, 21, 22, 23, 25, 26, 27, 28, 30, 32];
export const COMMERCIAL_VEHICLE_TYPE_IDS_EXCLUDING_MEDIUM_DUTY = [38, 40, 41];
export const MOTORCYCLE_VEHICLE_TYPE_ID = vehiclesEligibleForMCTagging;
export const GENERIC_OTHER_SERVICE_BARCODE = 911000;
export const COMMERCIAL_OTHER_TYPE_ID = 41;
export const MARINE_OR_RV_VEHICLES_TYPE_IDS = [20, 23, 25, 26, 27, 28];
export const NO_DATA_AVAILABLE = 'No data is available for the current selection';
/* Represents value of redbook control number from vehicleConfigurationAttribute that needs to be mapped to vehicle domain */
export const REDBOOK_CONTROL_NUMBER_ATTRIBUTE_LABEL = 'controlNumber';
export const COMMERCIAL_VEHICLE_TYPE = [
    VehicleTypeFlags.COMMERCIAL_HEAVYTRUCK,
    VehicleTypeFlags.COMMERCIAL_MEDIUMTRUCK,
    VehicleTypeFlags.GENERIC_COMMERCIAL
];
//# sourceMappingURL=VehicleConstants.js.map